import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Select, { SelectProps } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import { setGenderFilter } from '@apps/shared/src/providerSearch/actions';

import { RootState } from '../../store';
import { IncompleteTheme } from '../../shared/types/theme';

const Header = styled(Typography)(({ theme }) => ({
  ...(theme as IncompleteTheme).sidebar.headerText,
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  ...(theme as IncompleteTheme).selectMenuItem,
  display: 'block',
  padding: '12px 16px',
  minHeight: '48px',
}));

const StyledSelect = styled(Select)({
  width: '100%',
  '& .MuiSelect-select': {
    background: '#ffffff',
    border: '1px solid #E5EBF5',
    padding: '12px 16px',
  },
});

const mapStateToProps = ({ providerSearch }: RootState): StateProps => ({
  providergendercode: providerSearch.providergendercode,
  isLoading: providerSearch.isLoadingProviderList,
});

type StateProps = {
  providergendercode: string;
  isLoading: boolean;
};

const mapDispatchToProps = {
  setGenderFilter,
};

type Props = StateProps & typeof mapDispatchToProps;

const getGenderValue = (gender: string) => {
  if (gender === 'M') {
    return 'Male';
  }
  if (gender === 'F') {
    return 'Female';
  }
  return 'All';
};

export function GenderFilter({
  isLoading,
  providergendercode,
  setGenderFilter,
}: Props): JSX.Element {
  const [selectedOption, setSelectedOptions] = useState(
    providergendercode && providergendercode.length <= 1
      ? getGenderValue(providergendercode)
      : 'All'
  );
  const genderOptions = ['All', 'Male', 'Female'];

  const renderMenuItemValue: SelectProps['renderValue'] = selected => selected as string;

  useEffect(() => {
    setSelectedOptions(
      providergendercode && providergendercode.length <= 1
        ? getGenderValue(providergendercode)
        : 'All'
    );
  }, [providergendercode]);

  const handleGenderChange: SelectProps['onChange'] = e => {
    const gender = e.target.value as string;
    setSelectedOptions(gender);
    setGenderFilter(gender);
  };

  return (
    <div>
      <Header>Gender</Header>
      <StyledSelect
        labelId="Gender"
        id="gender-search"
        value={selectedOption}
        onChange={handleGenderChange}
        disableUnderline
        disabled={isLoading}
        renderValue={renderMenuItemValue}
      >
        {genderOptions.map(option => (
          <StyledMenuItem key={option} value={option}>
            {option}
          </StyledMenuItem>
        ))}
      </StyledSelect>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(GenderFilter);
